// extracted by mini-css-extract-plugin
export default {"btn":"Iaa","label_container":"Jaa","selected":"Kaa","iconbtn":"Laa","img_container":"Maa","no-img":"Naa","button-text":"Oaa","label":"Paa","btn_checked":"Qaa","btn_unchecked":"Raa","free_form":"Saa","free_form_input":"Taa"};
    if(module.hot) {
      // 1738836199050
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  